<div class="ds-notification-info" *ngIf="navigationInteractionsService.navigationItems.getValue().length && !isDemo">
  <div>
    <i class="db-icon db-icon-ds-info-bg"></i>
    <p>
      <span>{{ 'text_dragAndDropTheItemsToOrganizeYourMenu' | dbText }}</span>
    </p>
  </div>
</div>
<section class="db-ecommerce-menu-structure-wrapper">
  <div class="db-ecommerce-menu-structure-add"
       [class.disabled]="opened"
       (click)="openSlider.emit(); $event.stopPropagation()">
    <span class="add-item-btn">
       <i class="db-icon db-icon-ds-add"></i>
      <span class="text-underline">{{ 'text_addItem' | dbText }}</span>
    </span>
  </div>
  <div class="db-ecommerce-menu-structure-drag-container"
       [class.hidden]="!items.length"
       *ngIf="!isDemo && (navigationInteractionsService.navigationItems|async) as items"
       [dragula]='"navigation"'
       [(dragulaModel)]="menuItems">
    <ng-container *ngFor="let menuItem of items;let i = index">
      <db-ecommerce-navigation-item [ngClass]="navigationInteractionsService.checkLayer(menuItem)" [menuItem]="menuItem">
      </db-ecommerce-navigation-item>
    </ng-container>
  </div>
  <div class="db-ecommerce-menu-structure-drag-container"
       [class.hidden]="!items.length"
       *ngIf="isDemo && (navigationInteractionsService.navigationItems|async) as items">
    <ng-container *ngFor="let menuItem of items;let i = index">
      <db-ecommerce-navigation-item [ngClass]="navigationInteractionsService.checkLayer(menuItem)" [menuItem]="menuItem">
      </db-ecommerce-navigation-item>
    </ng-container>

  </div>
</section>
